module.exports = __webpack_public_path__ + "img/search-icon.35f02038.svg";